import type { Key } from 'react';
import { useEffect, useState } from 'react';

import { StyledSlider, StyledThumb, StyledTrack } from './styles';

interface DeferredSliderProps {
	value: number;
	min: number;
	max: number;
	onChange: (value: number) => void;
}

export const DeferredSlider = ({
	value,
	min,
	max,
	onChange,
}: DeferredSliderProps) => {
	const [localValue, setLocalValue] = useState(value);

	useEffect(() => {
		setLocalValue(value);
	}, [value]);

	const Track = (
		{ key, ...props }: { key?: Key | null },
		state: { index: number }
	) => <StyledTrack key={key} {...props} index={state.index} />;
	const Thumb = (
		{ key, ...props }: { key?: Key | null },
		state: { valueNow: number }
	) => (
		<StyledThumb key={key} {...props}>
			{state.valueNow}
		</StyledThumb>
	);

	return (
		<StyledSlider
			renderThumb={Thumb}
			renderTrack={Track}
			value={localValue}
			min={min}
			max={max}
			onChange={(value) => {
				setLocalValue(value);
				onChange(value);
			}}
		/>
	);
};
